import {
  faArrowUpRightAndArrowDownLeftFromCenter,
  faFrame,
  faMerge,
  faPaperPlane,
  faScaleBalanced,
} from '@fortawesome/pro-duotone-svg-icons'
import { FC } from 'react'
import GradientSection from '../../../shared/components/GradientSection'

const items = [
  {
    itemTitle: 'Truth-Seeking',
    itemDescription:
      'We embrace honesty, diverse perspectives, and candid conversations. Guided by transparency, we tackle challenges with integrity and rigorous analysis.',
    icon: faScaleBalanced,
  },
  {
    itemTitle: 'Responsibility',
    itemDescription:
      'We balance freedom with accountability. We take personal ownership of our actions and honor our commitments across our professional and personal lives.',
    icon: faFrame,
  },
  {
    itemTitle: 'Unity',
    itemDescription:
      'We are united by a shared purpose to build something meaningful. Through empathy and collaboration, we cultivate a supportive culture where everyone belongs.',
    icon: faMerge,
  },
  {
    itemTitle: 'Stretching',
    itemDescription:
      'We prioritize continuous growth. Rather than finding fault, we embrace challenges as opportunities to learn from our mistakes and move forward quickly.',
    icon: faArrowUpRightAndArrowDownLeftFromCenter,
  },
  {
    itemTitle: 'Transformation',
    itemDescription:
      'We thrive on adaptation and bold experimentation. By taking calculated risks and iterating rapidly, we drive innovation and create lasting change.',
    icon: faPaperPlane,
  },
]

const OurValuesSection: FC = () => <GradientSection title="Our values" items={items} />

export default OurValuesSection
